import { Form, message } from 'antd'
import { useContext } from 'react'
import { useMutation } from 'react-query'
import Context from '../Context'
import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'
import find from 'lodash/find'
import size from 'lodash/size'
import { UserInterface } from 'Interfaces'
import useLogAction from 'hooks/useLogAction'
import { userInfo } from 'os'

const updateUser = async ({
  uuid,
  new_firstname,
  new_lastname,
  new_phone,
  new_email
}) => {
  const data = await axiosRequest({
    url: '/admin/users',
    method: 'patch',
    data: { uuid, new_firstname, new_lastname, new_phone, new_email }
  })

  if (size(get(data, 'response.data.error'))) throw new Error('Request Error')

  return data.data
}

const useUpdateUser = () => {
  const [form] = Form.useForm()
  const { logAction } = useLogAction()
  const {
    states: { selectedUser },
    actions: { onClose, setSelectedUser, setDirtyBit },
    queryHandler: { data: dataQuery }
  } = useContext(Context)

  const data = get(dataQuery, 'data', [])
  const user: UserInterface =
    find(data, ({ identity_uuid }) => selectedUser === identity_uuid) ?? {}

  const { isLoading, mutate } = useMutation({
    mutationKey: 'update_user',
    mutationFn: updateUser,
    onSuccess: () => {
      onClose()
      const newUser = form.getFieldsValue(true)
      logAction({
        action: "UPDATE", event: "AIRFIND_USER", metadata: {
          actionType: "editAirfindUserInfo",
          lastUserInfo: {
            uuid: selectedUser,
            firstname: user?.identity_first_name,
            lastname: user?.identity_last_name,
            email: user?.identity_email,
            phone: user?.identity_phone
          },
          userInfo: {
            uuid: selectedUser,
            firstname: newUser.new_firstname,
            lastname: newUser.new_lastname,
            email: newUser.new_email,
            phone: newUser.new_phone
          }
        }
      })
      setSelectedUser('')
      setDirtyBit(true)
      message.success({
        type: 'success',
        content: 'El usuario fue actualizado correctamente'
      })
    },
    onError: () => {
      message.error({
        type: 'error',
        content: 'Ha ocurrido un error'
      })
    }
  })

  const onClick = () => {
    form
      .validateFields()
      .then(() => {
        mutate({ ...form.getFieldsValue(true), uuid: selectedUser })
      })
      .catch(() => {})
  }

  return {
    onClick,
    form,
    isLoading
  }
}

export default useUpdateUser
